export default "__VITE_ASSET__BtBZ8LsY__"